<template>
	<div class="box">
		<div class="topbox">
			<div>
				<el-row class="head1">
					<el-col :span="1" style="width: 50px;text-align: center">
						姓名:
					</el-col>
					<el-col :span="1" style="width: 128px">
						<el-input size="small" placeholder="请输入姓名" v-model="input1" @keyup.enter.native="search">
						</el-input>
					</el-col>
					<el-col :span="1" style="width: 90px;text-align: center">
						补签时间：
					</el-col>
					<el-col :span="1" style="width: 133px">
						<el-date-picker
							style="width: 100%"
							size="small"
							v-model="time1"
							type="date"
							value-format="yyyy-MM-dd"
							placeholder="选择日期">
						</el-date-picker>
					</el-col>
					<el-col :span="1" style="width: 50px;text-align: right">
						<el-button icon="el-icon-search" @click="search" type="success" size="small"></el-button>
					</el-col>
				</el-row>

			</div>

		</div>

		<div class="bodbox">
			<div class="bodc">
				<tiao :neir="'会员信息'"></tiao>
				<div class="tablebox">
					<table class="table table-bordered table-hover">
						<thead>
							<tr>
								<th>姓名</th>
								<th>别名</th>
								<th>月龄</th>
								<th>家长姓名</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in vip_list" @click="course_data(item.user_id)" style="cursor: pointer;">
								<td>{{item.baobao_name ? item.baobao_name : '--'}}</td>
								<td>{{item.baobao_name2 ? item.baobao_name2 : '--'}}</td>
								<td>{{item.yueling ? item.yueling : '--'}}</td>
								<td>{{item.name ? item.name : '--'}}</td>
							</tr>
							<tr>
								<td colspan="4" v-show="data_state" class="no_data">暂无数据</td>
							</tr>
						</tbody>

					</table>
				</div>
			</div>

			<div class="bodc">
				<tiao :neir="'补签课程'"></tiao>
				<div class="tablebox">
					<table class="table table-bordered table-hover">
						<thead>
							<tr>
								<th>课程/班级名称</th>
								<th>上课时间</th>
								<th>教室</th>
								<th>任课老师</th>
								<th>状态</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item,index) in course_list">
								<td>{{item.kc_name ? item.kc_name : '--'}}</td>
								<td>{{item.s_time ? item.s_time : '--'}}</td>
								<td>{{item.content ? item.content : '--'}}</td>
								<td>
									<el-row style="width: 100px;margin: 0 auto">
										<el-col :span="24">
											<el-select v-model="item.teacher" size="mini" placeholder="请选择">
												<el-option v-for="(data,dataindex) in item.laoshi" :key="dataindex" :label='data.username' :value='data.user_id'>
												</el-option>
											</el-select>
										</el-col>
									</el-row>
								</td>
								<td>
									<button @click="follow(index,item.qian_status,item.teacher,item.pk_id,item.xiaohao,item.sk_id)"
										:class="item.qian_status == 0 ? 'btn_state' : 'btn_state2'">
									   {{item.qian_status == 0 ? '未签到' : '已签到'}}
									</button>
								</td>
							</tr>
							<tr>
								<td colspan="5" v-show="data_state" class="no_data">暂无数据</td>
							</tr>
						</tbody>

					</table>
				</div>
			</div>
		</div>

		<!--签到-->
		<el-dialog
		  title="提示"
		  :visible.sync="sign_dialog"
		  width="30%">
		  <span>是否要签到？</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="sign_dialog = false">取 消</el-button>
		    <el-button type="success" @click="confirm_sign">确 定</el-button>
		  </span>
		</el-dialog>

		<!--取消签到-->
		<el-dialog
		  title="提示"
		  :visible.sync="cancel_dialog"
		  width="30%">
		  <span>是否取消签到？</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="cancel_dialog = false">取 消</el-button>
		    <el-button type="success" @click="cancel_sign">确 定</el-button>
		  </span>
		</el-dialog>

		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
			<span>这是一段信息</span>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="success" @click="dialogVisible = false">确 定</el-button>
		    </span>
		</el-dialog>
	</div>
</template>

<script>
	import tiao from '@/components/tiao.vue'
	export default {
		components: {
			tiao
		},
		data() {
			return {
				input2: '',
				options: [],//选择课程
				value: [],
				dialogVisible: false,
				vip_list:[],//搜索
				input1: '',
				time1: '',
				data_state:true,
				course_list:[],//补签课程
				vip_id:'',//会员ID
				sign_dialog:false,//签到
				cancel_dialog:false,//取消
		        n_id:'',//签到数据
				t:'',
				p_id:'',
				xh:'',
				s_id:'',
				q_index:'',
				k_index:'',
				token:'',
				loadings:''
			}
		},
        mounted(){
            this.token = $.cookie('token');
    },
		methods: {
			//搜索
			search(){
				if(this.time1 == ''){
					this.$message.error({
						message:'请选择补签时间'
					})
					return false;
				}
				let that =this
				this.vip_id=""
				$.ajax({
                    url:process.env.apiUrl + "saas/Qiandao/cha",
                    type:"post",
                    dataType:'json',
                    data:{
                        token:that.token,
                        name:that.input1,
                        time:that.time1
                    },
                    success:function(data){
                	   that.data_state=false
                	   that.vip_list=data.data
                       that.course_list=data.allkecheng.kecheng
						that.course_data(data.user_id);
                    }
                });
			},
			//补签课程
			course_data(id){
				this.vip_id=id
				let that =this
				$.ajax({
                    url:process.env.apiUrl + "saas/Qiandao/ke",
                    type:"post",
                    dataType:'json',
                    data:{
                        token:that.token,
                        user_id:id,
                        time:that.time1
                    },
                    success:function(data){
                	   that.course_list=data.kecheng
                    }
                });
			},
			//签到数据
			follow(i,id,t,p_id,xh,s_id){
				this.n_id=id
				this.t=t
				this.p_id=p_id
				this.xh=xh
				this.s_id=s_id
				this.q_index=i
				if(this.vip_id==""){
					this.$message({
					  message: '请先点击选择补签会员',
					  type: 'warning'
					});
				 	return
				}
				let that =this
				if(id==0){
					that.confirm_sign()
				}else if(id==1){
					that.cancel_sign()
				}
			},
			//确认签到
			confirm_sign(){

                this.$confirm('确认要签到吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let that = this
                    this.loadings = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    $.ajax({
                        url:process.env.apiUrl + "saas/Qiandao/bu",
                        type:"post",
                        dataType:'json',
                        data:{
                            token:that.token,
                            user_id:that.vip_id,
                            time:that.time1,
                            teacher:that.t,
                            pk_id:that.p_id,
                            xiaohao:that.xh
                        },
                        success:function(data){

                            if(data.status == 1){
                                for(let i=0;i<that.course_list.length;i++){
                                    if(that.p_id == i){
                                        that.course_list[i].qian_status = 1
                                    }
                                }
                                that.course_data(that.vip_id);
                            }else{
                                that.$message.error(data.msg);
							}
                            that.loadings.close()
                        }
                    });

                }).catch(() => {
                });
			},
			//取消签到
			cancel_sign(){

                this.$confirm('确认要取消签到吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let that = this
                    this.loadings = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    $.ajax({
                        url:process.env.apiUrl + "saas/Qiandao/quxiao",
                        type:"post",
                        dataType:'json',
                        data:{
                            token:that.token,
                            sk_id:that.s_id
                        },
                        success:function(data){
                            if(data.status == 1){
                                for(let i=0;i<that.course_list.length;i++){
                                    if(that.p_id == i){
                                        that.course_list[i].qian_status = 0
                                    }
                                }
                                that.course_data(that.vip_id);
                            }
                            that.loadings.close();
                        }
                    });

                }).catch(() => {
                });

			},
			jump: function(d) {
				this.$router.push(d)
			},
			change: function(item, index) {
				console.log(item);
				this.value[index] = item;
			},
			buqian: function(i) {
				this.dialogVisible = true
			},

		}
	}
</script>

<style scoped>
	.btn_state{
		padding: 3px 4px;
	    border: 0;
	    border-radius: 2px;
	    background: #8CBB77;
	    color: white;
	    cursor: pointer;
	}
	.btn_state2{
		padding: 3px 4px;
	    border: 0;
	    border-radius: 2px;
	    background: #5cb85c;
	    color: white;
	    cursor: pointer;
	}
	.el-button--small, .el-button--small.is-round{
		padding: 8px 15px;
	}

	* {
		font-size: 14px;
		color: #666;
	}

	.box {
		padding-left: 35px;
		padding-right: 35px;
		padding-top: 15px;
	}

	.topbox {
		height: 60px;
		display: flex;
		display: -webkit-flex;
		justify-content: flex-end;
	}

	.head1 {
		height: 32px;
		line-height: 32px;
	}

	.bodbox {
		display: flex;
		display: -webkit-flex;
	}

	.bodc {
		width: 50%;
		padding-left: 10px;
		padding-right: 10px;
	}

	.bodc:nth-of-type(1) {
		border-right: 1px solid #f2f2f2;
	}

	.tablebox {
		padding-left: 5px;
		padding-right: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/qiandao/buqian.vue